/* eslint-disable import/no-duplicates */
import { AnyAction, applyMiddleware, combineReducers, createStore, Reducer, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk, { ThunkDispatch } from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory, History } from 'history';
import {
  adminReducer,
  adminState,
  AppState,
  ratesReducer,
  ratesState,
  reservationsReducer,
  reservationsState,
  setupReducer,
  setupState
} from './store.types';
import { authenticationReducer } from '../modules/authentication/reducers/authentication.reducer';
import { coreReducer } from '../modules/core/reducers';
import {
  LOCALSTORAGE_ACTIVE_SUPPLIER,
  LOCALSTORAGE_RATES_REQUEST_TEST_FILTERS,
  LOCALSTORAGE_SUPPLIERS,
  LOCALSTORAGE_TOKEN_FIELD,
  LOCALSTORAGE_USER_FIELD
} from '../types/app.index';
import { UserModel } from '../api/authentication/authentication.types';
import { RatesRequestTestParameters } from '../api/pricing/pricing.types';
import { SupplierModel } from '../api/admin/admin.types';

const rootReducer: (history: History) => Reducer<AppState> = (history) => combineReducers<AppState>({
  router: connectRouter(history),
  rates: ratesReducer,
  authentication: authenticationReducer,
  core: coreReducer,
  setup: setupReducer,
  reservation: reservationsReducer,
  admin: adminReducer
});

export const history: History = createBrowserHistory();

const storedUserString = localStorage.getItem(LOCALSTORAGE_USER_FIELD) ?? null;
let storedUser: UserModel | null = null;
const storedToken = localStorage.getItem(LOCALSTORAGE_TOKEN_FIELD) ?? null;
const storedSuppliersString = localStorage.getItem(LOCALSTORAGE_SUPPLIERS) ?? null;
let storedSuppliers: SupplierModel[] | null = null;
const storedactiveSupplierString = localStorage.getItem(LOCALSTORAGE_ACTIVE_SUPPLIER) ?? null;
let storedActiveSupplier: SupplierModel | null = null;
const storedRatesRequestTestFiltersString = localStorage.getItem(LOCALSTORAGE_RATES_REQUEST_TEST_FILTERS) ?? null;
let storedRatesRequestTestFilters: RatesRequestTestParameters | null = null;

if (storedSuppliersString) {
  storedSuppliers = JSON.parse(storedSuppliersString);
}

if (storedactiveSupplierString) {
  storedActiveSupplier = JSON.parse(storedactiveSupplierString);
}

if (storedUserString) {
  storedUser = JSON.parse(storedUserString);
}

if (storedRatesRequestTestFiltersString) {
  storedRatesRequestTestFilters = JSON.parse(storedRatesRequestTestFiltersString);
}

const updatedRatesState = ratesState;
updatedRatesState.ratesRequestTest.filters = storedRatesRequestTestFilters;

const initialState: AppState | any = {
  rates: updatedRatesState,
  setup: setupState,
  reservation: reservationsState,
  admin: adminState,
  router: history,
  authentication: {
    user: storedUser,
    token: storedToken,
    loginFailed: false,
    suppliers: storedSuppliers,
    activeSupplier: storedActiveSupplier
  }
};

const configureStore = (): Store<AppState> => {
  const composeEnhancers = composeWithDevTools({});
  return createStore(
    rootReducer(history),
    initialState,
    composeEnhancers(
      applyMiddleware(
        thunk,
        routerMiddleware(history)
      )
    )
  );
};

export const store = configureStore();

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
export type ReduxState = ReturnType<typeof rootReducer>;
export type TypedDispatch = ThunkDispatch<ReduxState, any, AnyAction>;
